import {NODETYPE} from "./vnode";
import {forEach} from "../core/collections";
import {compileStyles} from "./util";
import {setEvent} from "../dom/event";
import {render} from "./render";

function setElementProps(element, node, view) {
    if (node.attrs) {
        forEach(node.attrs, (val, key) => {
            if (key === 'style') {
                val = compileStyles(val, ' ')
            }
            element.setAttribute(key, val)
        })
    }

    if (node.events) {
        forEach(node.events, (v, k) => {
            if (view) v = v.bind(view)
            setEvent(element, k, v)
        })
    }
}

/**
 * create Dom element(s) and set VNode.target
 * fragment must have parent div
 *
 * @param node
 * @param element
 * @param view
 * @returns {HTMLElement|Element|Node}
 */
export function renderDom(node, element, view) {
    let isView = false
    if (node.isView) {
        isView = true
        if (!node.$node) {
            node = render(node)
        }
        view = node
        node = view.$node
    }
    if (node.isFrag) {
        if (!element) {
            console.trace('fragment has no parent Element')
            element = document.createElement('div')
        }
        node.target = element
        if (view) view.target = element
        // renderDomChildren(node, element, view)
        if (node.nodes) {
            for (const child of node.nodes) {
                if (child.isFrag) {
                    // fragment child
                    renderDom(child, element, view)
                } else {
                    element.append(renderDom(child, undefined, view))
                }
            }
        }
        // //
        if (isView && view.onMount) view.onMount.call(view)
        return element
    }

    if (node.isText) {
        element = document.createTextNode(node.text)
        node.target = element
        return element
    }

    if (!element) {
        element = document.createElement(node.$tag)
    }

    node.target = element
    if (view) view.target = element

    if (!node.isFrag) setElementProps(element, node, view)
    else console.error('render-dom: something broke!',node)
    // renderDomChildren(node, element, view)
    if (node.nodes) {
        for (const child of node.nodes) {
            if (child.isFrag) {
                // fragment child
                renderDom(child, element, view)
            } else {
                element.append(renderDom(child, undefined, view))
            }
        }
    }
    // //
    return element
}

function renderDomChildren(node, element, view) {
    if (node.nodes) {
        for (const child of node.nodes) {
            if (child.isFrag) {
                // fragment child
                renderDom(child, element, view)
            } else {
                element.append(renderDom(child, undefined, view))
            }
        }
    }
}